module.exports = __webpack_public_path__ + "static/img/news2.4402b08e.png";